<div class="toolbar">
  <button matButton="elevated" class="toolbarButton primary-button" [disabled]="isBusy() || !isChanged()" (click)="saveChanges()">
    Save
  </button>
</div>
<div class="content">
  <div class="input-section">
    <div class="input-row">
      @if (bottomInsulationCutback) {
        <div class="configuration-input">
          <label class="input-label">Riser Bottom Insulation Cutback:</label>
          <select class="input-field" #bottomInsulationCutbackInput [disabled]="isBusy()"
            [class.invalidConfigurationSelection]="isInvalid(bottomInsulationCutback)"
            (change)="validateSelections(bottomInsulationCutback, bottomInsulationCutbackInput.value)"
            [value]="bottomInsulationCutback.Value.toString()">
            @for (allowable of bottomInsulationCutback.Allowables; track allowable) {
              <option
                [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                [selected]="bottomInsulationCutback.Value && bottomInsulationCutback.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}
              </option>
            }
          </select>
        </div>
      }
      @if (topInsulationCutback) {
        <div class="configuration-input">
          <label class="input-label">Riser Top Insulation Cutback:</label>
          <select class="input-field" #topInsulationCutbackInput [disabled]="isBusy()"
            [class.invalidConfigurationSelection]="isInvalid(topInsulationCutback)"
            (change)="validateSelections(topInsulationCutback, topInsulationCutbackInput.value)"
            [value]="topInsulationCutback.Value.toString()">
            @for (allowable of topInsulationCutback.Allowables; track allowable) {
              <option
                [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                [selected]="topInsulationCutback.Value && topInsulationCutback.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}
              </option>
            }
          </select>
        </div>
      }
    </div>
    <div class="input-row">
      @if (riserEndTreatment) {
        <div class="configuration-input">
          <label class="input-label">Riser End Treatment:</label>
          <select class="input-field" #riserEndTreatmentInput [disabled]="isBusy()"
            [class.invalidConfigurationSelection]="isInvalid(riserEndTreatment)"
            (change)="validateSelections(riserEndTreatment, riserEndTreatmentInput.value)"
            [value]="riserEndTreatment.Value.toString()">
            @for (allowable of riserEndTreatment.Allowables; track allowable) {
              <option
                [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                [selected]="riserEndTreatment.Value && riserEndTreatment.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}
              </option>
            }
          </select>
        </div>
      }
    </div>
  </div>
  <div class="input-section">
    <div class="section-header">
      Supply/Return Riser Options
    </div>
    <div class="input-row">
      @if (riserCopperType) {
        <div class="configuration-input">
          <label class="input-label">Copper Type:</label>
          <select class="input-field" #copperTypeInput [disabled]="isBusy()"
            [class.invalidConfigurationSelection]="isInvalid(riserCopperType)"
            (change)="validateSelections(riserCopperType, copperTypeInput.value)"
            [value]="riserCopperType.Value.toString()">
            @for (allowable of riserCopperType.Allowables; track allowable) {
              <option
                [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                [selected]="riserCopperType.Value && riserCopperType.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}
              </option>
            }
          </select>
        </div>
      }
    </div>
    <div class="input-row">
      @if (supplyInsulation) {
        <div class="configuration-input">
          <label class="input-label">Supply Insulation:</label>
          <select class="input-field" #supplyInsulationInput [disabled]="isBusy()"
            [class.invalidConfigurationSelection]="isInvalid(supplyInsulation)"
            (change)="validateSelections(supplyInsulation, supplyInsulationInput.value)"
            [value]="supplyInsulation.Value.toString()">
            @for (allowable of supplyInsulation.Allowables; track allowable) {
              <option
                [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                [selected]="supplyInsulation.Value && supplyInsulation.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}
              </option>
            }
          </select>
        </div>
      }
      @if (returnInsulation) {
        <div class="configuration-input">
          <label class="input-label">Return Insulation:</label>
          <select class="input-field" #returnInsulationInput [disabled]="isBusy()"
            [class.invalidConfigurationSelection]="isInvalid(returnInsulation)"
            (change)="validateSelections(returnInsulation, returnInsulationInput.value)"
            [value]="returnInsulation.Value.toString()">
            @for (allowable of returnInsulation.Allowables; track allowable) {
              <option
                [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                [selected]="returnInsulation.Value && returnInsulation.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}
              </option>
            }
          </select>
        </div>
      }
    </div>
  </div>
  <div class="input-section">
    <div class="section-header">
      Drain Riser Options
    </div>
    <div class="input-row">
      @if (drainCopperType) {
        <div class="configuration-input">
          <label class="input-label">Copper Type:</label>
          <select class="input-field" #drainCopperTypeInput [disabled]="isBusy()"
            [class.invalidConfigurationSelection]="isInvalid(drainCopperType)"
            (change)="validateSelections(drainCopperType, drainCopperTypeInput.value)"
            [value]="drainCopperType.Value.toString()">
            @for (allowable of drainCopperType.Allowables; track allowable) {
              <option
                [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                [selected]="drainCopperType.Value && drainCopperType.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}
              </option>
            }
          </select>
        </div>
      }
      @if (drainInsulationThickness) {
        <div class="configuration-input">
          <label class="input-label">Insulation Thickness:</label>
          <select class="input-field" #drainInsulationThicknessInput [disabled]="isBusy()"
            [class.invalidConfigurationSelection]="isInvalid(drainInsulationThickness)"
            (change)="validateSelections(drainInsulationThickness, drainInsulationThicknessInput.value)"
            [value]="drainInsulationThickness.Value.toString()">
            @for (allowable of drainInsulationThickness.Allowables; track allowable) {
              <option
                [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                [selected]="drainInsulationThickness.Value && drainInsulationThickness.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}
              </option>
            }
          </select>
        </div>
      }
    </div>
  </div>
</div>
